import { IconType } from '@factorialco/factorial-one-react'
import { People, VideoRecorder } from '@factorialco/factorial-one-react/icons/app'

import i18n from 'modules/core/lib/i18n'

export const getMeetingTypeTitle = (meetingType: string) => {
  switch (meetingType) {
    case 'one_on_one':
      return i18n.t('meetings.meeting.type.one_on_one')
    default:
      return i18n.t('meetings.meeting.type.default')
  }
}

export const getMeetingTypeIcon = (meetingType: string): IconType => {
  switch (meetingType) {
    case 'one_on_one':
      return People
    default:
      return VideoRecorder
  }
}
